import React from 'react';

import LabelFilterWrap from 'components/molecules/LabelFilterWrap';
import MbPopper from 'components/molecules/MbPopper';

/**
 * 테이블 popover 되는 필터 wrapper
 * @param {json} param0
 */
export default class PopoverFilterWrap extends React.Component {
  constructor(props) {
    super(props);
    this.anchorRef = React.createRef();

    const {
      createOnOpen = false,
      getOnClose = (f) => f,
      handleSave = (f) => f,
    } = props;
    this.state = {
      createOnOpen,
      open: false,
    };

    // 필터창 닫을 함수 리턴
    if (!!handleSave) {
      handleSave(this.handleClose);
    }

    getOnClose(this.handleToggle);
  }

  handleToggle = () => {
    this.setState({
      ...this.state,
      createOnOpen: false,
      open: !this.state.open,
    });
  };

  handleClose = (event) => {
    const { anchorRef } = this;
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    this.setState({
      ...this.state,
      createOnOpen: false,
      open: false,
    });
  };

  render() {
    const { anchorRef, handleToggle, handleClose } = this;
    const { createOnOpen, open } = this.state;
    const {
      selectedLabel,
      className,
      label,
      filtered,
      id,
      filterList,
      popoverHeight,
      popoverMaxWidth,
      style,
    } = this.props;
    return (
      <>
        <LabelFilterWrap
          className={className}
          label={label}
          filtered={filtered}
          onClick={handleToggle}
          anchorRef={anchorRef}
          style={style}
        >
          {selectedLabel}
        </LabelFilterWrap>
        <MbPopper
          open={open}
          anchorRef={anchorRef}
          onClickAway={open ? handleClose : (f) => f}
          id={id}
          popoverHeight={popoverHeight}
          popoverMaxWidth={popoverMaxWidth}
        >
          {!createOnOpen && filterList}
        </MbPopper>
      </>
    );
  }
}
